module.exports = __webpack_public_path__ + "static/media/checkRed.de58e09e.svg";